export default __webpack_public_path__ + "static/23-ef84b1bed6506da32b35f1d0c26ce758.png";